import {ChildNodesItemChunk} from "../../chunks/types/ChildNodesItemChunk";
import {getChildNameFromNodeDeclChunk} from "./getChildNameFromNodeDeclChunk";

export function getChildNameFromChildNodesItemChunk(
  childNodesItemChunk: ChildNodesItemChunk
): string {
  const {captures: {1: nodeDeclChunk}} = childNodesItemChunk;
  return getChildNameFromNodeDeclChunk(nodeDeclChunk);
}
